<template>
  <div>
    <Modal
      v-model="openFujian"
      title="上传附件"
      footer-hide
      width="400"
      height="400"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :label-width="80">
        <input id="licensePicFile" type="file" />
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button type="primary" @click="submit('item')">提交附件</Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openFujian: false,
      item: { id: "", licensePic: "" },
    };
  },
  methods: {
    reachData(v) {
      this.openFujian = true;
      this.item.id=v.id
    },
    submit() {
      let params = new window.FormData();
      params.append("licensePic", this.item.licensePic);
      params.append("id", this.item.id);
      params.append(
        "licensePicFile",
        document.getElementById("licensePicFile").files[0]
      );
      console.log(document.getElementById("licensePicFile").files[0]);
      axios({
        method: "post",
        url: axios.dm + "/driver/uploadAnnex",
        data: params,
      }).then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          if (res.data.code == 200) {
            this.cliclCancelBtn();
            this.$Message.success("上传成功");
          } else {
            this.$Message.error(res.data.message);
          }
        }
      });
    },
    cliclCancelBtn() {
      this, (this.openFujian = false);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/information/fujian.vue